import React from 'react';
import { StatusChip } from '../../ui-kit';
import { ConfirmDialog } from '../../components/dialog';
import type { TenantAgent } from '../../services/tenantAgentsService';

/**
 * Whether an agent is working: On or Off, at the top of its own page. It is
 * switched from the ⋯ menu on its card on the Agents page. Off stops all its
 * background work — no new leads read, no calls, no emails, its phone and chat
 * hooks refuse — but its screens still open with everything it did.
 */
export default function AgentOnOff({ agent }: { agent: Pick<TenantAgent, 'on'> }) {
  const on = agent.on !== false;
  return <StatusChip tone={on ? 'good' : 'neutral'} label={on ? 'On' : 'Off'} />;
}

/**
 * "Switch it off?" — asked from the ⋯ menu on an agent's card on the Agents page.
 */
export function SwitchAgentDialog({
  agent, on, open, busy, onClose, onConfirm,
}: {
  agent: Pick<TenantAgent, 'name'>;
  on: boolean;
  open: boolean;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      busy={busy}
      tone={on ? 'warning' : 'neutral'}
      title={on ? `Switch ${agent.name} off?` : `Switch ${agent.name} on?`}
      description={on
        ? 'It stops working straight away: nothing new is read, sent or called, and its phone and chat lines stop '
          + 'answering. Everything it has done stays here, and you can switch it back on at any time.'
        : 'It starts working straight away, with the settings on its Configuration page. An agent that calls or '
          + 'messages people will do so for real.'}
      confirmLabel={on ? 'Switch off' : 'Switch on'}
    />
  );
}
